import React, { Component } from 'react';
import PropTypes from 'prop-types';
import uuid from 'uuid';
import _isEqual from 'lodash/isEqual';

import { dictionariesEntry, dictionariesColumn } from 'types';

import Checkbox from 'components/Checkbox';
import TrashPopConfirm from 'components/TrashPopConfirm';
import RowColumnInput from '../RowColumnInput';
import './style.scss';

class TableRow extends Component {
  static propTypes = {
    entry: dictionariesEntry,
    entryIndex: PropTypes.number,
    columns: PropTypes.arrayOf(dictionariesColumn),
    selection: PropTypes.arrayOf(PropTypes.string),
    focus: PropTypes.shape({
      row: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
      col: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    }),
    onFocus: PropTypes.func.isRequired,
    onRemoveRow: PropTypes.func.isRequired,
    onUpdateRow: PropTypes.func.isRequired,
    onSave: PropTypes.func.isRequired,
    onSelect: PropTypes.func.isRequired,
  };

  static defaultProps = {
    columns: [],
  };

  shouldComponentUpdate(nextProps) {
    return (
      !_isEqual(nextProps.entry, this.props.entry) ||
      !_isEqual(nextProps.columns, this.props.columns) ||
      !_isEqual(nextProps.selection, this.props.selection) ||
      [this.props.focus.row, nextProps.focus.row].includes(nextProps.entryIndex)
    );
  }

  componentDidUpdate() {
    const { focus, entryIndex } = this.props;
    if (focus.row === entryIndex && focus.col === -1) {
      this.inputComponent.focus();
    }
  }

  handleClick = () => {
    const { entryIndex, onFocus } = this.props;
    onFocus({
      row: entryIndex,
      col: -1,
    });
  };

  handleRemoveRow = () => {
    const { entry, onRemoveRow } = this.props;
    onRemoveRow(entry.id);
  };

  handleChangeValue = async ({ target: { value } }) => {
    await this.props.onUpdateRow(this.props.entry, 'token', value);
    this.saveRowUpdate(this.props.entry);
  };

  saveRowUpdate = entry => {
    this.props.onSave(entry);
  };

  handleSelect = () => {
    const { entry, onSelect } = this.props;
    onSelect(entry.id);
  };

  handleRef = el => {
    this.inputComponent = el;
  };

  handleKeyDown = e => {
    if (e.key === 'Enter') {
      this.inputComponent.blur();
    }
  };

  render() {
    const {
      entry,
      entryIndex,
      columns,
      focus,
      onFocus,
      onUpdateRow,
    } = this.props;
    const { token } = entry;
    const isSelected = this.props.selection.indexOf(entry.id) >= 0;

    /* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
    /* eslint-disable jsx-a11y/click-events-have-key-events */

    return (
      <tr styleName="row">
        <td styleName="selection-wrap">
          <Checkbox
            styleName="selection"
            type="checkbox"
            isSmall
            isChecked={isSelected}
            title="Select entry to delete"
            onClick={this.handleSelect}
          />
        </td>

        <td>
          <input
            ref={this.handleRef}
            defaultValue={token}
            onClick={this.handleClick}
            onBlur={this.handleChangeValue}
            onKeyDown={this.handleKeyDown}
            data-test="token-input"
          />
        </td>

        {columns.map((col, index) => (
          <RowColumnInput
            col={col}
            entry={entry}
            entryIndex={entryIndex}
            index={index}
            key={col.id || uuid()}
            focus={focus}
            saveOnEnterPress
            onFocus={onFocus}
            onUpdateRow={onUpdateRow}
            onSaveRowUpdate={this.saveRowUpdate}
          />
        ))}

        <td styleName="trash-wrap">
          <TrashPopConfirm
            styleName="trash"
            text="Delete this entry?"
            onDelete={this.handleRemoveRow}
          />
        </td>
      </tr>
    );
  }
}

export default TableRow;
